module.exports = __webpack_public_path__ + "img/calendar_btn.1b64d1f9.svg";